import { Box, IconButton } from '@mui/material'
import { Dismiss16Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { AttachmentPreviewIcon, formatBytes, fileTypeLabel } from './attachmentMeta'
import styles from './index.module.scss'

export default function AttachmentComposerChipDoc({ file, uploadState, uploadError, onRemove }) {
  const stateClass = uploadState === 'error' ? ` ${styles.fileChipUploadError}` : ''
  // A saved document shows its type and size, like the Recent cards: nothing is
  // being read until a submitted question needs it.
  const info =
    uploadState === 'uploading'
      ? 'Uploading...'
      : uploadState === 'error'
        ? uploadError || 'Upload failed'
        : `${fileTypeLabel(file)} ${formatBytes(file.size)}`
  return (
    <Box className={`${styles.fileChip}${stateClass}`}>
      <Box className={styles.fileIconPreview} aria-hidden>
        <AttachmentPreviewIcon file={file} />
      </Box>
      <Tooltip
        text={file.name}
        placement="top"
        maxLines={2}
        bubbleMaxWidth="100px"
        rootClassName={styles.tooltipRootFileMeta}
      >
        <Box className={styles.fileMeta}>
          <Box component="span" className={styles.fileName}>
            {file.name}
          </Box>
          <Box component="span" className={styles.fileInfo}>
            {info}
          </Box>
        </Box>
      </Tooltip>
      <Tooltip text="remove" placement="top">
        <IconButton
          type="button"
          size="small"
          className={styles.fileRemove}
          onClick={onRemove}
          aria-label={`Remove ${file.name}`}
        >
          <Dismiss16Regular className={styles.fileRemoveIcon} aria-hidden />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
